export const ACTION = {
    SEE_ALL_CONTENT: 'SEE-ALL-CONTENT',
    CLEAR_CONTENT: 'CLEAR-CONTENT',
};

export const SEE_ALL_LIMIT = 20;